import { jsx as _jsx } from "react/jsx-runtime";
import { JsonForms } from '@jsonforms/react';
import { materialCells } from '@jsonforms/material-renderers';
import { jsonFormsMaterialRenderers } from '../../../renders/jsonFormsRenders';
const FormView = (props) => {
    const { data, schema, uiSchema, validationMode = 'ValidateAndShow', renderers = jsonFormsMaterialRenderers, cells = materialCells, style, middleware, ajv, onFormStateChange, readonly = false, config, } = props;
    const onFormStateChanged = (state) => {
        void onFormStateChange?.(state);
    };
    return (_jsx("div", { style: style, children: _jsx(JsonForms, { schema: schema, uischema: uiSchema, data: data, renderers: renderers, cells: cells, onChange: onFormStateChanged, validationMode: validationMode, middleware: middleware, ajv: ajv, readonly: readonly, config: config }) }));
};
export default FormView;
